import { buildApiUrl } from "../../services/apiConfig";

class AuthoringService {
  async triggerWorkfrontIngest(issueId) {
    return fetch(buildApiUrl('CG', '/trigger-ingest-workfront'), {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ issue_id: issueId })
    }).then(res => res.json());
  }

  async generateContent(prompt) {
    return fetch(buildApiUrl('AEM_RAG', '/rag_authoring'), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: prompt }),
    }).then(res => res.json());
  }

  async generateChart(data, chartPrompt) {
    return fetch(buildApiUrl('CHART', '/api/embed'), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        source_type: "json",
        input: JSON.stringify(data),
        query: chartPrompt,
      }),
    }).then(res => res.text());
  }

  async exportToAEM(payload) {
    return fetch(buildApiUrl('CG', '/publish-content-fragment'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(res => res.text());
  }

  async exportToWord(widgets) {
    return fetch(buildApiUrl('EXPORT', '/export-to-word'), {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ widgets })
    });
  }
}

export default new AuthoringService();